import { publicEnv } from "./public";
import { serverEnv } from "./server";

export const env = {
  ...publicEnv,
  ...serverEnv,
};
